import { render, staticRenderFns } from "./PopupCreateOrder.vue?vue&type=template&id=5f032672"
import script from "./PopupCreateOrder.vue?vue&type=script&lang=js"
export * from "./PopupCreateOrder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports